<template>
  <v-card>
    <v-card-text>
      <form-group>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
          >
            <input-radio
              v-model="payload.status"
              :options="options"
              row
              :rules="[requiredRule]"
            />
          </v-flex>
          <v-flex
            v-if="isSchedule"
            xs12
          >
            <v-layout>
              <v-flex>
                <date-picker
                  id="input:schedule"
                  v-model="schedule.date"
                  label="Data de envio"
                  :rules="[requiredRule]"
                  required
                />
              </v-flex>
              <v-flex>
                <input-text
                  id="input:hours"
                  v-model="schedule.hours"
                  label="Horário do envio"
                  mask="##:##"
                  placeholder="12:00"
                  :rules="[requiredRule]"
                  required
                />
              </v-flex>
              <v-flex />
            </v-layout>
          </v-flex>
          <v-flex
            xs12
          >
            <input-text
              id="input:titulo"
              v-model="payload.titulo"
              label="Título"
              :rules="[requiredRule, maxLength(20)]"
              counter="20"
              outlined
              required
            />
          </v-flex>
          <v-flex xs12>
            <input-text-area
              id="input:descricao"
              v-model="payload.descricao"
              label="Descrição"
              :rules="[requiredRule, maxLength(160)]"
              rows="5"
              counter="160"
              outlined
            />
          </v-flex>
        </v-layout>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import InputText from 'Support/components/inputs/InputText.vue';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import rulesMixin from 'Support/mixins/rules-mixin';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import communicationStatus from './communicationStatus';

const [, ...options] = communicationStatus.map(
  ({ text, ...rest }) => {
    const option = {
      ...rest,
      label: text,
    };

    switch (rest.value) {
      case 'ENVIADA': {
        option.label = 'Enviar agora';
        break;
      }
      case 'AGENDADA': {
        option.label = 'Agendar';
        break;
      }
      default:
        break;
    }

    return option;
  },
);

export default {
  name: 'CommunicationManagerContent',
  components: {
    FormGroup,
    InputText,
    InputTextArea,
    InputRadio,
    DatePicker,
  },
  mixins: [rulesMixin],
  data: () => ({
    options,
    schedule: {
      date: '',
      hours: '',
    },
  }),
  computed: {
    payload() {
      return this.store.payload;
    },
    isSchedule() {
      return this.payload.status === 'AGENDADA';
    },
    store() {
      return this.communicationData;
    },
    getDate() {
      const { date, hours } = this.schedule;
      const [h = '1', h1 = '2', m = '0', m1 = '0'] = hours.split('');
      return `${date}T${h + h1}:${m + m1}:00.000Z`;
    },
  },
  watch: {
    getDate: {
      immediate: true,
      handler(date) {
        if (date && typeof date === 'string') {
          this.store.setKeyData(
            'schedule',
            date,
          );
        }
      },
    },
  },
  inject: {
    communicationData: {
      default() {
        return {
          payload: {},
        };
      },
    },
  },
};
</script>
